import React from 'react'

import Layout from '../components/Layout'
import Paper from '../components/Paper'
import SEO from '../components/Seo'

import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { Grid } from '@material-ui/core'

import Typography from '../components/Typography'

import compStyles from '../pageComponents/home/home.module.scss'

const PicturesPage = (props) => {
  const images = useStaticQuery(graphql`
    query {
      placeholderImage: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "pictures"}}) {
        edges{
          node{
            base
              childImageSharp {
                fluid(quality: 100, maxWidth: 400, maxHeight: 280) {
                  ...GatsbyImageSharpFluid
                }
              }
          }
        }
      }
    }
  `)
  
  return (
  <Layout>
    <SEO title='ಚಿತ್ರ ಪಟಗಳು' />
    <Paper>
      <Typography variant="h2" className={compStyles.about__heading}>ಚಿತ್ರ ಪಟಗಳು</Typography>
      <Grid container direction="row"  justify="space-around" alignItems="center">
        {
          images.placeholderImage.edges.map( (banner, index) => {
            return (<Grid item  md={4}  key={index} className={compStyles.gallery__item}>
              <Img className={compStyles.pictures__image} fixed={banner.node.childImageSharp.fluid} />
            </Grid>)
          })
        }
      </Grid>
    </Paper>
  </Layout>
  )
}

export default PicturesPage
